const users = {
    name: 'Users/UsersPage',
    path: '/users',
    icon: 'mdi-account-group',
    label: 'Users'
};

const organizations = {
    name: 'Organizations/OrganizationsPage',
    path: '/organizations',
    icon: 'mdi-domain',
    label: 'Organizations'
};

const members = {
    name: 'Members/MembersPage',
    path: '/members',
    icon: 'mdi-card-account-details',
    label: 'Members'
};

const assessmentCustomization = {
    name: 'Assessments/AssessmentsPage',
    path: '/assessments',
    icon: 'mdi-clipboard-edit-outline',
    label: 'Assessments'
};

const account = {
    name: 'Dashboard/AccountPage',
    path: '/account',
    icon: 'mdi-account',
    label: 'Account'
};

const horizon = {
    name: 'Horizon',
    path: '/horizon',
    icon: 'mdi-sun-angle',
    label: 'Horizon',
    private: true,
    privateLabel: 'SA'
};

const pulse = {
    name: 'Pulse',
    path: '/pulse',
    icon: 'mdi-pulse',
    label: 'Pulse',
    private: true,
    privateLabel: 'SA'
};

const telescope = {
    name: 'Telescope',
    path: '/telescope',
    icon: 'mdi-telescope',
    label: 'Telescope',
    private: true,
    privateLabel: 'SA'
};

const profileDetails = {
    name: 'ProfileDetailsPage',
    path: '/profile-details',
    icon: 'mdi-account-circle',
    label: 'Profile'
};

const memberAssessments = {
    name: 'MemberAssessmentsPage',
    path: '/member-assessments',
    icon: 'mdi-clipboard-text-outline',
    label: 'Assessments'
};

const memberProfiles = {
    name: 'MemberProfilesPage',
    path: '/member-profiles',
    icon: 'mdi-folder-table-outline',
    label: 'Profiles'
};

export const superAdmin = _ => {
    return [
        users,
        organizations,
        members,
        assessmentCustomization,
    ];
};

export const admin = _ => {
    return [
        users,
        organizations,
        members,
        assessmentCustomization,
    ];
};

export const member = _ => {
    return [
        profileDetails,
        memberAssessments,
    ];
};

export const accessMember = _ => {
    return [
        memberProfiles,
        memberAssessments,
    ];
};

export const bottomNavRoutes = _ => {
    return [
        account,
        horizon,
        pulse,
        telescope,
    ];
};
